import { computed, ref, watch } from "vue";
const PAGE_SIZE = 50;
export function useActivityFilter(items) {
    const showUpdates = ref(true);
    const selectedDocumentType = ref("all");
    const displayCount = ref(PAGE_SIZE);
    const filteredItems = computed(() => {
        return items.value.filter((item) => {
            if (!showUpdates.value && item.eventType === "updated")
                return false;
            if (selectedDocumentType.value !== "all" && item.documentType !== selectedDocumentType.value)
                return false;
            return true;
        });
    });
    const visibleItems = computed(() => filteredItems.value.slice(0, displayCount.value));
    const hasMore = computed(() => filteredItems.value.length > displayCount.value);
    const remainingCount = computed(() => filteredItems.value.length - displayCount.value);
    function loadMore() {
        displayCount.value += PAGE_SIZE;
    }
    watch([selectedDocumentType, showUpdates], () => {
        displayCount.value = PAGE_SIZE;
    });
    return {
        showUpdates,
        selectedDocumentType,
        displayCount,
        filteredItems,
        visibleItems,
        hasMore,
        remainingCount,
        loadMore,
        PAGE_SIZE,
    };
}
